import type { UseQueryOptions } from '../../types'
import { useApi, useQuery } from '#imports'

export const useXmppConfig = (options: Omit<UseQueryOptions<any>, 'key'> = {}) => {
    const api = useApi()

    return useQuery(async ({ signal }) => {
        return api<any>('/gateway/ejabberd/public/xmpp-config', { signal })
    }, {
        server: false,
        ...options,
        key: 'core:xmpp:config',
    })
}
